import { render, staticRenderFns } from "./SearchCoordinators.vue?vue&type=template&id=88067c64&"
import script from "./SearchCoordinators.vue?vue&type=script&lang=js&"
export * from "./SearchCoordinators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports